import { useState } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { ClaimReward } from './ClaimReward';
import { RankComponent } from './RankComponent';
import { PackageRankMyProgressModel } from './Ranking.types';
import { Flexed } from '../../styles/GlobalComponents';

export const Ranking = ({
  ranking,
  isDashboard = false
}: {
  ranking: PackageRankMyProgressModel[];
  isDashboard?: boolean;
}) => {
  const [isRewardOpen, setIsRewardOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [selectedRank, setSelectedRank] =
    useState<PackageRankMyProgressModel | null>(null);

  const { t } = useTranslation('ranking');

  const handleClaim = (rank: PackageRankMyProgressModel) => {
    setStep(1);
    setIsRewardOpen(!isRewardOpen);
    setSelectedRank(rank);
  };

  const getNextRank = (ranking: PackageRankMyProgressModel[]) => {
    const nextRank = ranking.slice(0, -3)?.find((r) => r.isNextRank);
    if (!nextRank) {
      return ranking.slice(0, -3)[0];
    }
    return nextRank;
  };

  return (
    <>
      <Flexed column gap='30px' gapSM='15px'>
        {!isDashboard &&
          ranking?.slice(0, -3)?.map((rank, i) => {
            return (
              <RankComponent
                rank={rank}
                key={i}
                handleClaim={handleClaim}
                isDashboard={isDashboard}
              />
            );
          })}

        {isDashboard && getNextRank(ranking) && (
          <RankComponent
            rank={getNextRank(ranking)!}
            handleClaim={handleClaim}
            isDashboard={isDashboard}
          />
        )}
      </Flexed>
      <SidebarModal
        isOpen={isRewardOpen}
        setOpen={setIsRewardOpen}
        title={t('new_rank_achived')}
        sidebarWidth={'508px'}>
        <ClaimReward
          step={step}
          setStep={setStep}
          setIsOpen={setIsRewardOpen}
          selectedRank={selectedRank}
        />
      </SidebarModal>
    </>
  );
};
